<template>
    <div class="c-product-variations" :class="{'is-loading': isLoading}">
        <div class="c-product-variations__item" v-for="productVariation in productVariations" :key="productVariation.id">
            <div class="c-product-variations__title">
                <span class="sc-text">{{ productVariation.name }}</span>
                <span class="sc-value" v-if="productVariation.id == 4">{{ productVariation.selected.name }}</span>
                <i v-if="productVariation.custom_tooltip" class="ico ico-question-circle js-tippy" :data-tippy-content="productVariation.custom_tooltip"></i>
            </div>

            <div
                class="c-product-variations__content"
                :class="getContentClass(productVariation)"
            >
                <template v-for="(variationValue, index) in getSortedVariationValues(productVariation.variation_values)">
                    <template v-if="isImageSelect(productVariation) && variationValue.image">
                            <button
                                @click="checkAvailability(productVariation.id, variationValue.id) == 'enabled' ? selectVariationValue(variationValue) : false"
                                class="c-product-variations__button c-product-variations__button--image js-tippy-variation"
                                :data-tippy-content="checkAvailability(productVariation.id, variationValue.id) == 'enabled' ? imageTippyContent(variationValue) : unavailableTippyText(variationValue.name)"
                                :class="{...selectButtonClass(variationValue, index), ...{
                                    'js-tippy-destroy': checkAvailability(productVariation.id, variationValue.id) == 'enabled',
                                }}"
                                :data-disabled="checkAvailability(productVariation.id, variationValue.id)"
                                :key="variationValue.id"
                            >
                                <img class="c-img" :src="thumbnail(variationValue.image, 'xs')" :alt="variationValue.name" />
                                <span class="c-product-variations__button--price mobile-is-visible" v-if="variationValue.custom_price">+{{ formatPrice(variationValue.custom_price) }}</span>
                                <span class="c-product-variations__button--price is-discount" v-if="getDiscount(variationValue) > 0">-{{ getDiscount(variationValue) }}%</span>
                            </button>
                    </template>

                    <template v-else>
                        <button
                            @click="checkAvailability(productVariation.id, variationValue.id) == 'enabled' ? selectVariationValue(variationValue) : false"
                            class="c-product-variations__button c-product-variations__button--text"
                            :class="{...selectButtonClass(variationValue, index), ...{
                                'js-tippy-variation': checkAvailability(productVariation.id, variationValue.id) == 'disabled',
                                'js-tippy-destroy': checkAvailability(productVariation.id, variationValue.id) == 'enabled',
                            }}"
                            :data-tippy-content="unavailableTippyText(variationValue.name)"
                            :data-disabled="checkAvailability(productVariation.id, variationValue.id)"
                            :key="variationValue.id"
                        >
                            <span class="c-text">{{ variationValue.name }}</span>
                            <span class="c-price" v-if="variationValue.custom_price">+{{ formatPrice(variationValue.custom_price) }}</span>
                        </button>
                    </template>
                </template>

                <!-- https://riesenia.atlassian.net/browse/DUB-99 -->
                <button
                    v-if="false"
                    @click="expandMore(productVariation.id)"
                    class="c-product-variations__button c-product-variations__button--more"
                    :class="expandMoreClass(productVariation)"
                >
                    <img class="is-aspect-ratio-fix" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=">
                    <div class="is-content">
                        <span class="cxs-is-hidden">+{{ Object.values(productVariation.variation_values).length - getItemsToShow(productVariation, 'desktop') }}</span>
                        <span class="cxs-is-visible">+{{ Object.values(productVariation.variation_values).length - getItemsToShow(productVariation, 'phone') }}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { initTippy } from 'Functions/tippy';
import { thumbnail } from 'Functions/thumbnail';
import { formatPrice } from 'FrontendJsAssets/common/format';
import client from "FrontendJsAssets/common/client";

export default {
    name: 'variation-select',
    data() {
        return {
            isLoading: false,
            showMoreExpanded: [],
        }
    },
    mounted() {
        // remove placeholder
        document.querySelector('.js-product-variations-placeholder').remove()

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('variation') && this.product.product_variation_ids.includes(parseInt(urlParams.get('variation')))) {
            this.selectVariationValue(this.product.selected_variation_values[Object.keys(this.product.selected_variation_values)[0]])
        }

        this.$nextTick(() => {
            initTippy()
            initTippy('.js-tippy-variation', {
                theme: 'variation',
                arrow: false,
                popperOptions: {
                    modifiers: [{
                        name: 'flip',
                        options: {
                            fallbackPlacements: []
                        },
                    }],
                },
            })
        })
    },
    methods: {
        thumbnail: thumbnail.bind(this),

        formatPrice: formatPrice.bind(this),

        isSelected(variationValueId) {
            return Object.values(this.selectedVariationValues).includes(variationValueId)
        },

        selectVariationValue(changedVariationValue) {
            const variationValues = {...this.selectedVariationValues}
            this.isLoading = true

            variationValues[changedVariationValue.variation_id] = changedVariationValue.id;

            client.post(`${window.Eshop.options.baseUrl}catalog/get-product-variation-updated/${this.product.id}`, {
                changed_value: changedVariationValue ? changedVariationValue.id : null,
                variation_values: Object.values(variationValues),
                stock_only: window.location.search.includes('stock_only') ? 1 : 0
            }).then((response) => {
                // zmena obrazku podla variacie
                if (response.data.image_change_allowed) {
                    const slider = document.querySelector('r-slider[r-product-image-slider]').swiper;
                    const targetImgSlide = document.querySelector(`r-slider[r-product-image-slider] .swiper-slide[data-variation-value-id="${changedVariationValue.id}"]`)

                    if (targetImgSlide) {
                        slider.slideTo([...targetImgSlide.parentNode.children].indexOf(targetImgSlide))
                    } else {
                        slider.slideTo(0);
                    }
                }

                this.$parent.product = response.data.product
                window.productData = this.$parent.product

                window.rEvent.dispatch("VariationValue.changed", changedVariationValue);

                if (response.data.product.custom_delivery_info) {
                    document.querySelector('.js-delivery-info').outerHTML = response.data.product.custom_delivery_info
                }

                this.$emit('variation-changed', response.data)
            }).catch((error) => {
                console.error(error)
                // window.Eshop.tippyAlert(button, this.$t("AutocompleteResults.addToCartError"), {
                //     theme: 'error',
                //     appendTo: 'parent',
                // }, 2500)
            }).then(() => {
                this.isLoading = false

                document.querySelectorAll('.js-tippy-destroy').forEach((element) => {
                    if (element._tippy) {
                        element._tippy.destroy();
                    }
                })

                initTippy()
                initTippy('.js-tippy-variation', {
                    theme: 'variation',
                    arrow: false,
                    popperOptions: {
                        modifiers: [{
                            name: 'flip',
                            options: {
                                fallbackPlacements: []
                            },
                        }],
                    },
                })
            })
        },

        getContentClass(productVariation) {
            let cssClass = 'c-product-variations__content'

            if (productVariation.is_images || productVariation.id == 4 || productVariation.custom_image_select) {
                cssClass += '--images'
            } else {
                cssClass += '--text'
            }

            return cssClass
        },

        expandMoreClass(productVariation) {
            const productVariationId = productVariation.id

            if (this.showMoreExpanded.includes(productVariationId)) {
                return { 'hidden': true }
            }

            const itemsToShow = this.getItemsToShow(productVariation)
            const itemsCount = Object.values(productVariation.variation_values).length

            return {
                'cxs-is-visible': itemsToShow['phone'] <= itemsCount && itemsToShow['desktop'] >= itemsCount,
                'hidden': itemsToShow['phone'] >= itemsCount && itemsToShow['desktop'] >= itemsCount,
                'is-image-select': this.isImageSelect(productVariation),
                'is-text-select': !this.isImageSelect(productVariation),
            }
        },

        expandMore(productVariationId) {
            this.showMoreExpanded.push(productVariationId)
        },

        selectButtonClass(variationValue, index) {
            const cssClasses = {
                'is-selected': this.isSelected(variationValue.id)
            }

            //? https://riesenia.atlassian.net/browse/DUB-99
            if (false && !this.showMoreExpanded.includes(variationValue.variation_id)) {
                const itemsToShow = this.getItemsToShow(variationValue.variation_id)

                cssClasses['cxs-is-hidden'] = itemsToShow['phone'] <= index
                cssClasses['hidden'] = itemsToShow['desktop'] <= index
            }

            return cssClasses
        },

        imageTippyContent(variationValue) {
            return `
                <div class="c-tippy-variation">
                    <img class="c-img" src="${thumbnail(variationValue.image, 'xs')}" width="75" height="75" />
                    <span class="c-name">${variationValue.name}</span>
                    ` + (variationValue.custom_price ? `<span class="c-price" v-if="variationValue.custom_price">+${ formatPrice(variationValue.custom_price) }</span>` : ``) + `
                </div>
            `
        },

        getItemsToShow(productVariation, device = null) {
            let itemsToShow = {
                desktop: 9999,
                phone: 2
            }

            if (this.isImageSelect(productVariation)) {
                itemsToShow = {
                    desktop: 7,
                    phone: 5
                }
            }

            if (!device) {
                return itemsToShow
            }

            return itemsToShow[device]
        },

        isImageSelect(productVariation) {
            // TODO: variationIamgeSelect - je to image select?
            return productVariation.custom_image_select
        },

        getSortedVariationValues(variationValues) {
            return Object.values(variationValues).sort((a, b) => a.sort_variation - b.sort_variation)
        },

        getDiscount(variationValue) {
            const variationValues = {...this.selectedVariationValues}

            variationValues[variationValue.variation_id] = variationValue.id;

            const productVariation = this.getProductVariationByValues(variationValues)

            return productVariation && productVariation.stock > 0 && productVariation.stock_sale_applied ? (productVariation.custom_stock_sale_percentage || 0) : 0
        },

        getProductVariationByValues(variationValueIds) {
            // find product variation by selected variation values
            const productVariation = this.product.product_variations.filter((productVariation) => {
                return Object.entries(productVariation.variation_values).every(([variationId, variationValueId]) => {
                    return variationValueIds[variationId] == variationValueId
                })
            })

            return productVariation[0] || null
        },

        checkAvailability(variationId, variationValueId) {
            const stockOnly = window.location.search.includes('stock_only');

            if (!stockOnly) {
                return 'enabled';
            }

            if (!this.selectableIds[variationId]) {
                return 'disabled';
            }

            return this.selectableIds[variationId].includes(variationValueId) ? 'enabled' : 'disabled';
        },

        unavailableTippyText(variationName) {
            const productLinkElement = document.querySelector('.js-product-link');

            if (!productLinkElement) {
                return '';
            }

            const productLink = productLinkElement.href;
            const variationLink = `<a href="${productLink}" title="${this.$t('Variation.unavailableTippyLink')}">${this.$t('Variation.unavailableTippyLink')}</a>`;

            return this.$t('Variation.unavailableTippyText', { variationName, variationLink });
        }

    },
    computed: {
        product() {
            return this.$parent.product
        },
        selectedVariationValues() {
            const variationValues = {}

            for (const variatonValue of Object.values(this.product.selected_variation_values)) {
                variationValues[variatonValue.variation_id] = variatonValue.id
            }

            return variationValues
        },
        productVariations() {
            if (!this.product.has_variations) {
                return []
            }

            return this.product.variations.map((variation) => {
                return {...variation, ...{
                    variation_values: this.product.variation_values[variation.id],
                    selected: this.product.selected_variation_values[variation.id]
                }}
            })
        },
        selectableIds() {
            return this.product.custom_selectable_variation_ids || [];
        }
    }
};
</script>
